import { render } from "./carousel-holder.vue?vue&type=template&id=0c9da603"
import script from "./carousel-holder.vue?vue&type=script&lang=js"
export * from "./carousel-holder.vue?vue&type=script&lang=js"

import "./carousel-holder.vue?vue&type=style&index=0&id=0c9da603&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__